var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LogEncryptMode, LogType, ResultMsg } from './interface';
import Config from './global-config';
import { isValidDay, dateFormat2Day, logContentWrapper } from './lib/utils';
import LogManager from './log-manager';
import { GlobalHandlers } from './lib/integrations/globalhandlers';
import LoganDB from './lib/logan-db';
import { firstReport } from './lib/performance';
import reportLog, { immediateSend as reportLogImmediateSend } from './report-log';
import saveLog, { getLogCountAll } from './save-log';
var initConfigIsExec = false;
// const ES6Promise = require('es6-promise');
// if (!window.Promise) {
//     window.Promise = ES6Promise;
// }
var logQueueBeforeLoad = [];
function reportParamChecker(reportConfig) {
    if (!reportConfig) {
        throw new Error('reportConfig needs to be an object');
    }
    var dayFormatDesc = 'is not valid, needs to be YYYY-MM-DD format';
    if (!isValidDay(reportConfig.fromDayString)) {
        throw new Error("fromDayString " + dayFormatDesc);
    }
    if (!isValidDay(reportConfig.toDayString)) {
        throw new Error("toDayString " + dayFormatDesc);
    }
    if (reportConfig.fromDayString > reportConfig.toDayString) {
        throw new Error('fromDayString needs to be no bigger than toDayString');
    }
}
// function logParamChecker (logType: number, encryptVersion: LogEncryptMode): never | void {
//     if (typeof logType !== 'number') {
//         throw new Error('logType needs to be set');
//     }
//     // if (encryptVersion === LogEncryptMode.RSA) {
//     //     if (!Config.get('publicKey')) {
//     //         throw new Error(
//     //             'publicKey needs to be set before logWithEncryption'
//     //         );
//     //     }
//     // }
// }
function logAsync(logItem) {
    return __awaiter(this, void 0, void 0, function () {
        var count, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!LogManager.canSave()) return [3 /*break*/, 9];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, , 8]);
                    return [4 /*yield*/, saveLog(logItem)];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, getLogCountAll()];
                case 3:
                    count = _a.sent();
                    if (!(count >= Config.get('autoReportCount'))) return [3 /*break*/, 5];
                    return [4 /*yield*/, reportAll()];
                case 4:
                    _a.sent();
                    _a.label = 5;
                case 5: return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    LogManager.errorTrigger();
                    return [4 /*yield*/, Config.get('errorHandler')(e_1)];
                case 7:
                    _a.sent();
                    return [3 /*break*/, 8];
                case 8: return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, Config.get('errorHandler')(new Error(ResultMsg.EXCEED_TRY_TIMES))];
                case 10:
                    _a.sent();
                    _a.label = 11;
                case 11: return [2 /*return*/];
            }
        });
    });
}
function logIfLoaded(logItem) {
    if ((!document.readyState ||
        (document.readyState && document.readyState === 'complete')) &&
        initConfigIsExec) {
        logAsync(logItem);
    }
    else {
        logQueueBeforeLoad.push(logItem);
    }
}
function standardLog(content, logType, encryptVersion) {
    if (Config.get('stop'))
        return;
    // try {
    //     logParamChecker(logType, LogEncryptMode.PLAIN);
    // } catch (e) {
    //     (Config.get('errorHandler') as Function)(e);
    // }
    // content = typeof content === 'object' ? JSON.stringify(content) : content;
    var _devSend = Config.get('_devSend');
    if (process.env.NODE_ENV !== 'production' && !_devSend) {
        console.log("%cbigo-log", "border:1px solid #aaa;padding: 10px 5px;color: #f99418;font-weight: 500;", { logContent: content, pid: LoganDB.pageId, encryptVersion: encryptVersion });
        return;
    }
    logIfLoaded({
        logContent: logContentWrapper(content, logType),
        pid: LoganDB.pageId,
        encryptVersion: encryptVersion
    });
}
function onWindowLoad() {
    logQueueBeforeLoad.forEach(function (logItem) {
        logAsync(logItem);
    });
    logQueueBeforeLoad = [];
    window.removeEventListener('load', onWindowLoad);
}
window.addEventListener('load', onWindowLoad);
/**
 * Set global settings for this single Logan instance. Usually you only need to call this once after Logan is imported. Each time this method is called, all previous global configs will be overwritten by current settings.
 *
 * @param globalConfig Global settings
 */
export function initConfig(globalConfig) {
    var _a, _b;
    if (globalConfig.globalReportConfig) {
        globalConfig.globalReportConfig = Object.assign({
            langCode: navigator.language,
            environment: navigator && navigator.userAgent
        }, globalConfig.globalReportConfig);
        if (!globalConfig.globalReportConfig.userId) {
            // 兼容旧应用引入的代码
            if (typeof globalConfig.globalReportConfig.uid === 'string') {
                globalConfig.globalReportConfig.userId = globalConfig.globalReportConfig.uid;
                globalConfig.globalReportConfig.uid = 0;
            }
            else {
                globalConfig.globalReportConfig.userId = String(globalConfig.globalReportConfig.uid);
            }
        }
    }
    Config.set(globalConfig);
    var hooks = Config.get('hooks');
    var errorHandler = function (content, logType) {
        var _devSend = Config.get('_devSend');
        if (process.env.NODE_ENV !== 'production' && !_devSend) {
            return;
        }
        immediateSend({
            log_type: logType,
            log_content: content,
            type: 2,
        });
        // 报错后上报数据
        reportAll();
    };
    var globalHandlers = new GlobalHandlers({
        onxhr: hooks.xhr,
        onfetch: hooks.fetch,
        ondom: hooks.dom,
        // 本地开发环境默认不监听 console 
        onconsole: hooks.console,
        onhistory: hooks.history,
        onnativeapi: hooks.nativeapi,
        onerror: hooks.error,
        onunhandledrejection: hooks.unhandledrejection,
        logHandler: log,
        errorHandler: errorHandler
    });
    globalHandlers.setupOnce();
    // 每次进来都执行发送
    reportAll();
    // 执行进入页面的首次日志page请求
    var globalReportConfig = Config.get('globalReportConfig');
    if (((_a = globalReportConfig) === null || _a === void 0 ? void 0 : _a.device_id) || ((_b = globalReportConfig) === null || _b === void 0 ? void 0 : _b.userId)) {
        var _devSend = Config.get('_devSend');
        if (process.env.NODE_ENV !== 'production' && !_devSend) {
            return;
        }
        firstReport(globalReportConfig);
    }
    initConfigIsExec = true;
}
export function setConfig(globalConfig) {
    Config.set(globalConfig);
}
export function setConfigByKey(key, value) {
    Config.setKey(key, value);
}
/**
 * Save one log locally.
 * @param content Log content.
 * @param logType Log type.
 */
export function log(content, logType) {
    if (logType === void 0) { logType = 1; }
    if (Config.get('stop'))
        return;
    standardLog(content, logType, LogEncryptMode.PLAIN);
}
/**
 * 埋点上报
 * @param trackConfig
 * @returns Promise<any>
 */
export function track(trackConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var globalReportConfig, _devSend;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Config.get('stop'))
                        return [2 /*return*/];
                    globalReportConfig = Config.get('globalReportConfig');
                    if (!globalReportConfig.act_id && !trackConfig.act_id) {
                        console.error("%cbigo-log", "border:1px solid #aaa;padding: 10px 5px;color: #f99418;font-weight: 500;", '请在initConfig的globalReportConfig中传入act_id 或 track中传入act_id');
                        return [2 /*return*/];
                    }
                    if (trackConfig.isCN) {
                        Config.setKey('isCN', trackConfig.isCN);
                    }
                    if (typeof trackConfig.log_action === 'number') {
                        trackConfig.log_action = String(trackConfig.log_action);
                    }
                    _devSend = Config.get('_devSend');
                    if (process.env.NODE_ENV !== 'production' && !_devSend) {
                        console.log("%cbigo-log-track", "border:1px solid #aaa;padding: 10px 5px;color: #f99418;font-weight: 500;", trackConfig);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, immediateSend(__assign(__assign({}, trackConfig), { log_type: LogType.TRACK, type: 2 }))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
// /**
//  * Save one confidential log locally. Before saving, the log content will be encrypted and it is very hard to crack after then.
//  * @param content Log content.
//  * @param logType Log type.
//  */
// export function logWithEncryption (content: string, logType: LogType): void {
//     if (Config.get('stop')) return;
//     standardLog(content, logType, LogEncryptMode.RSA);
// }
// /**
//  * Save custom formatted log content locally.
//  * @param {LogConfig} logConfig
//  */
// export function customLog (logConfig: LogConfig): void {
//     if (Config.get('stop')) return;
//     logIfLoaded({
//         logContent: logConfig.logContent,
//         pid: logConfig.pid,
//         encryptVersion: logConfig.encryptVersion
//     });
// }
export function reportAll() {
    return __awaiter(this, void 0, void 0, function () {
        var now, sevenDaysAgo, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    now = new Date();
                    sevenDaysAgo = new Date(+now - 6 * 24 * 3600 * 1000);
                    return [4 /*yield*/, report({
                            fromDayString: dateFormat2Day(sevenDaysAgo),
                            toDayString: dateFormat2Day(now)
                        })];
                case 1:
                    res = _a.sent();
                    return [2 /*return*/, res];
            }
        });
    });
}
/**
 * Report local logs to the server side.
 *
 * @param reportConfig Config for this report.
 * @returns {Promise<ReportResult>} Reject with an Error if anything goes wrong during the report process. Resolve ReportResult if the process is successful.
 */
export function report(reportConfig) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (Config.get('stop'))
                        return [2 /*return*/];
                    reportParamChecker(reportConfig);
                    return [4 /*yield*/, reportLog(__assign(__assign({}, Config.get('globalReportConfig')), reportConfig))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function immediateSend(sendConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var globalReportConfig;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    globalReportConfig = Config.get('globalReportConfig');
                    return [4 /*yield*/, reportLogImmediateSend(__assign(__assign({}, globalReportConfig), sendConfig))];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function stop() {
    setConfigByKey('stop', true);
}
export function resume() {
    setConfigByKey('stop', false);
}
export function destroy() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    stop();
                    return [4 /*yield*/, LoganDB.deleteAll()];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
if (process.env.NODE_ENV === 'development') {
    window.Logger = {
        initConfig: initConfig,
        log: log,
        report: report,
        ResultMsg: ResultMsg,
        reportAll: reportAll,
        setConfig: setConfig,
        setConfigByKey: setConfigByKey,
        immediateSend: immediateSend,
        track: track,
        destroy: destroy
    };
}
